<!--
    资源统计
-->
<template>
    <div class="page userPage">
        <el-row :gutter="20">
            <el-col :span="6">
                <statistics-multi-orgs @orgsChange="orgsChange" @dataLoaded="orgDataLoaded"></statistics-multi-orgs>
            </el-col>
            <el-col :span="18">
                <ui-card :title="$t('count.resType')" icon="nucfont inuc-menu-assemble" class="ibox">
                    <el-row class="content_detail">
                        <el-col class="resource-type">
                            <div class="document-style" @click="btnSourceType('document')">
                                <p class="img-num">{{documentNum}}</p>
                                <p class="img-type">{{documentName}}</p>
                                <p class="rate">{{documentRate}}</p>
                            </div>
                        </el-col>
                        <el-col class="resource-type">
                            <div class="video-style" @click="btnSourceType('video')">
                                <p class="img-num">{{videoNum}}</p>
                                <p class="img-type">{{videoName}}</p>
                                <p class="rate">{{videoRate}}</p>
                            </div>
                        </el-col>
                        <el-col class="resource-type">
                            <div class="picture-style" @click="btnSourceType('picture')">
                                <p class="img-num">{{pictureNum}}</p>
                                <p class="img-type">{{pictureName}}</p>
                                <p class="rate">{{pictureRate}}</p>
                            </div>
                        </el-col>
                        <el-col class="resource-type">
                            <div class="audio-style" @click="btnSourceType('audio')">
                                <p class="img-num">{{audioNum}}</p>
                                <p class="img-type">{{audioName}}</p>
                                <p class="rate">{{audioRate}}</p>
                            </div>
                        </el-col>
                    </el-row>
                </ui-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <statistics-upload-top ref="upload"
                                   :statisticName="$t('count.uploadRank')+'(TOP10)'"
                                   :sourceType="sourceType"
                                   id="resource"
                                   :uploadData="uploadData"></statistics-upload-top>
        </el-row>
    </div>
</template>
<script>
    import api from '@/api';
    import {mapGetters} from 'vuex';
    import {Debounce} from '@/utils';
    import StatisticsMultiOrgs from '@/components/Statistics/StatisticsMultiOrgs';
    import StatisticsUploadTop from "@/components/Statistics/StatisticsUploadTop";
    import uiCard from '@/components/Statistics/StatisticUICard';

    var echarts = require('echarts');
    export default {
        data() {
            return {
                searchData: {
                    orgIds: [],
                    type: undefined,
                },
                sourceType: this.$t('c.all'),
                documentName: '',
                videoName: '',
                pictureName: '',
                audioName: '',
                documentNum: 0,
                videoNum: 0,
                pictureNum: 0,
                audioNum: 0,
                documentRate: '0%',
                videoRate: '0%',
                pictureRate: '0%',
                audioRate: '0%',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                uploadOrderShow: false,

                uploadData: [],
                isDocument: false,
                isVideo: false,
                isPicture: false,
                isAudio: false,
            };
        },
        created() {
        },
        mounted() {
           this.getUploadOrder();
        },
        computed: {
            ...mapGetters([
                'orgTree',
            ])
        },
        methods: {
            orgDataLoaded() {
                $('.el-tree > .el-tree-node').find('.el-checkbox:eq(0)').click();
            },
            btnSourceType(value) {
                if (value === 'document') {
                    this.isDocument = !this.isDocument;
                    this.isVideo = false;
                    this.isPicture = false;
                    this.isAudio = false;
                    if (this.isDocument) {
                        this.searchData.type = 'Document';
                        this.sourceType = this.$t('c.document');
                    } else {
                        this.searchData.type = undefined;
                        this.sourceType = this.$t('c.all');
                    }
                }
                if (value === 'video') {
                    this.isDocument = false;
                    this.isVideo = !this.isVideo;
                    this.isPicture = false;
                    this.isAudio = false;
                    if (this.isVideo) {
                        this.searchData.type = 'Video';
                        this.sourceType = this.$t('c.video');
                    } else {
                        this.searchData.type = undefined;
                        this.sourceType = this.$t('c.all');
                    }
                }
                if (value === 'picture') {
                    this.isDocument = false;
                    this.isVideo = false;
                    this.isPicture = !this.isPicture;
                    this.isAudio = false;
                    if (this.isPicture) {
                        this.searchData.type = 'Picture';
                        this.sourceType = this.$t('c.image');
                    } else {
                        this.searchData.type = undefined;
                        this.sourceType = this.$t('c.all');
                    }
                }
                if (value === 'audio') {
                    this.isDocument = false;
                    this.isVideo = false;
                    this.isPicture = false;
                    this.isAudio = !this.isAudio;
                    if (this.isAudio) {
                        this.searchData.type = 'Audio';
                        this.sourceType = this.$t('c.audio');
                    } else {
                        this.searchData.type = undefined;
                        this.sourceType = this.$t('c.all');
                    }
                }
                this.getUploadOrder(this.searchData);
            },
            orgsChange: Debounce(function (data) {
                this.sourceType = this.$t('c.all');
                this.searchData.orgIds = data;
                let searchData = {
                    orgIds: this.searchData.orgIds,
                    type: undefined
                };
                this.getType(searchData);
                this.getUploadOrder(searchData);
            }, 600),
            getType(data) {
                api.getResourceByType(data).then((res) => {
                    if (res.package.length > 0) {
                        this.documentName = res.package[0].name;
                        this.videoName = res.package[1].name;
                        this.pictureName = res.package[2].name;
                        this.audioName = res.package[3].name;
                        this.documentNum = res.package[0].value;
                        this.videoNum = res.package[1].value;
                        this.pictureNum = res.package[2].value;
                        this.audioNum = res.package[3].value;
                        let total = this.documentNum + this.videoNum + this.pictureNum + this.audioNum;
                        this.documentRate = total == 0 ? ('0.00%') : (Math.round(this.documentNum / total * 10000) / 100 + "%");
                        this.videoRate = total == 0 ? ('0.00%') : (Math.round(this.videoNum / total * 10000) / 100 + "%");
                        this.pictureRate = total == 0 ? ('0.00%') : (Math.round(this.pictureNum / total * 10000) / 100 + "%");
                        this.audioRate = total == 0 ? ('0.00%') : (Math.round(this.audioNum / total * 10000) / 100 + "%");
                    }
                })
            },
            getUploadOrder(data) {
                api.getResourceUpLoadCount(data).then((res) => {
                    if (res.package) {
                        this.uploadFunction(res.package, 'resource')
                    } else {
                        this.uploadFunction([])
                    }
                });
            },
            uploadFunction(data, id) {
                this.$refs.upload.upLoadSeption(data, id)
            }
        },
        watch: {},
        components: {
            StatisticsUploadTop,
            StatisticsMultiOrgs,
            uiCard
        }
    };
</script>
<style scoped lang="scss">
    @import '../../style/const';

    .page {
        & /deep/ .el-card {
            border: none;
        }
        & /deep/ .el-card.is-always-shadow {
            box-shadow: none;
        }
    }

    .content_detail {
        padding: 20px;
        display: flex;
        .resource-type {
            flex: 1;
            margin: 0 3px;
            .document-style,
            .video-style,
            .picture-style,
            .audio-style {
                width: 100%;
                height: 110px;
                margin: 60px auto;
                cursor: pointer;
                position: relative;
                p {
                    color: #fff;
                    text-align: center;
                    &.rate {
                        position: absolute;
                        bottom: 10px;
                        right: 15px;
                        font-size: 20px;
                    }
                    &.img-num {
                        font-size: 30px;
                        padding: 15px 0 5px;
                    }
                    &.img-type {
                        font-size: 20px;
                    }
                }
            }
            .document-style {
                background: #589fd5;
                background-image: url(../../assets/images/statistic/bg_statistic_blue.jpg);
                background-size: cover;
            }
            .video-style,.audio-style {
                background: #fab160;
                background-image: url(../../assets/images/statistic/bg_statistic_yellow.jpg);
                background-size: cover;
            }
            .picture-style {
                background: #eb7162;
                background-image: url(../../assets/images/statistic/bg_statistic_pink.jpg);
                background-size: cover;
            }
        }
    }

</style>


